import React from "react";
import { useTheme } from '../../../../contexts/ThemeContext';

const DocumentTabs = ({ tabs, activeTab, onTabChange }) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="border-b border-gray-200 dark:border-gray-700 transition-colors duration-200">
      <nav className="-mb-px flex space-x-8 px-6" aria-label="Tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
              transition-all duration-200 transform hover:scale-[1.02]
              ${
                activeTab === tab.id
                  ? "border-blue-500 text-blue-600 dark:text-blue-400"
                  : "border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600"
              }
            `}
          >
            <span className={`mr-2 transition-colors duration-200 ${activeTab === tab.id ? 'text-blue-500 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`}>
              {tab.icon}
            </span>
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default DocumentTabs;
